/*
 * @Author: your name
 * @Date: 2021-05-18 09:36:45
 * @LastEditTime: 2021-05-18 10:20:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ipublishment-ssr-web/components/ipub-ui/src/index.js
 */
// import locale from './utils/locale';

import Button from '../packages/button'
import Label from '../packages/label'
import Icon from '../packages/icon'
import Row from '../packages/row'
import Col from '../packages/col'
import Input from '../packages/input'
import Textarea from '../packages/textarea'
import Dropdown from '../packages/dropdown'
import Menus from '../packages/menus'
import MenusItem from '../packages/menus-item'
import Select from '../packages/select'
import SelectOption from '../packages/select-option'
import IpubPagination from '../packages/pagination'
import IpubBacktop from '../packages/backtop'
import IpubLoading from '../packages/loading'
import IpubForm from '../packages/form'
import IpubFormItem from '../packages/form-item'
import IpubDatePicker from '../packages/date-picker'
import IpubTimePicker from '../packages/time-picker'
import IpubDateTimePicker from '../packages/date-time-picker'
import IpubDateRangePicker from '../packages/date-range-picker'
import IpubEditor from '../packages/editor'
import IpubUpload from '../packages/upload'
import IpubUploadInput from '../packages/upload-input'
import IpubUploadLabel from '../packages/upload-label'
import IpubRadio from '../packages/radio'
import IpubRadioGroup from '../packages/radio-group'
import IpubModel from '../packages/model'
import IpubConfirm from '../packages/confirm'
import IpubMessage from '../packages/message'
import IpubBreadcrumb from '../packages/breadcrumb'
import IpubTable from '../packages/table'
import IpubEmpty from '../packages/empty'
import IpubTree from '../packages/tree'
import IpubTreeItem from '../packages/tree-item'
import IpubTooltip from '../packages/tooltip'
import IpubProgress from '../packages/progress'
import IpubSlider from '../packages/slider'
import IpubDragArea from '../packages/drag-area'
// import IpubUploadCropper from '../packages/upload-cropper'
const IpubUploadCropper = async () => {
  return (await import('../packages/upload-cropper')).default
}

// import { version } from "./package.json";
const components = [
  Button,
  Label,
  Icon,
  Row,
  Col,
  Input,
  Textarea,
  Dropdown,
  Menus,
  MenusItem,
  Select,
  SelectOption,
  IpubPagination,
  IpubBacktop,
  IpubLoading,
  IpubForm,
  IpubFormItem,
  IpubDatePicker,
  IpubTimePicker,
  IpubDateTimePicker,
  IpubDateRangePicker,
  IpubEditor,
  IpubUpload,
  IpubUploadInput,
  IpubUploadLabel,
  IpubRadio,
  IpubRadioGroup,
  IpubModel,
  IpubBreadcrumb,
  IpubTable,
  IpubEmpty,
  IpubTree,
  IpubTreeItem,
  IpubTooltip,
  IpubProgress,
  IpubSlider,
  IpubDragArea
  // IpubUploadCropper
]
const version = '0.0.1'

const install = async function(Vue) {
  // const install = function(Vue, opts = {}) {
  // 判断是否安装
  // if (install.installed) return;
  // locale.use(opts.locale);
  // locale.i18n(opts.i18n);

  components.forEach(component => {
    Vue.component(component.name, component)
  })

  try {
    if (window) {
      const component = await IpubUploadCropper()
      Vue.component(component.name, component)
    }
  } catch (e) {
    throw e
  }

  Vue.use(IpubConfirm)
  Vue.use(IpubMessage)
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export {
  Button,
  Label,
  Icon,
  Row,
  Col,
  Input,
  Textarea,
  Dropdown,
  Menus,
  MenusItem,
  Select,
  SelectOption,
  IpubPagination,
  IpubBacktop,
  IpubLoading,
  IpubForm,
  IpubFormItem,
  IpubDatePicker,
  IpubTimePicker,
  IpubDateTimePicker,
  IpubDateRangePicker,
  IpubEditor,
  IpubUpload,
  IpubUploadInput,
  IpubUploadLabel,
  IpubRadio,
  IpubRadioGroup,
  IpubModel,
  IpubBreadcrumb,
  IpubTable,
  IpubEmpty,
  IpubTree,
  IpubTreeItem,
  IpubTooltip,
  IpubProgress,
  IpubSlider,
  IpubDragArea,
  IpubConfirm,
  IpubMessage,
  IpubUploadCropper
}
export default {
  version,
  install,
  Button,
  Label,
  Icon,
  Row,
  Col,
  Input,
  Textarea,
  Dropdown,
  Menus,
  MenusItem,
  Select,
  SelectOption,
  IpubPagination,
  IpubBacktop,
  IpubLoading,
  IpubForm,
  IpubFormItem,
  IpubDatePicker,
  IpubTimePicker,
  IpubDateTimePicker,
  IpubDateRangePicker,
  IpubEditor,
  IpubUpload,
  IpubUploadInput,
  IpubUploadLabel,
  IpubRadio,
  IpubRadioGroup,
  IpubModel,
  IpubBreadcrumb,
  IpubTable,
  IpubEmpty,
  IpubTree,
  IpubTreeItem,
  IpubTooltip,
  IpubProgress,
  IpubSlider,
  IpubDragArea,
  IpubConfirm,
  IpubMessage,
  IpubUploadCropper
}
// export default { version, install }
